import View from "./View";

class homeView extends View {
  _parentElement = document.querySelector(".welcome");
}

export default new homeView();
